import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { type ReactElement } from 'react';
import { type ImageWithFallbackProps } from '@shared/ui-components/image-with-fallback/image-with-fallback';
import { LockIcon } from '@shared/ui-components/svgs';
import { ImageWrapper } from '../../../../../../components/image-wrapper/image-wrapper';
import { SvgNumber01 } from './number-01';
import { SvgNumber02 } from './number-02';
import { SvgNumber03 } from './number-03';
import { SvgNumber04 } from './number-04';
import { SvgNumber05 } from './number-05';
import { SvgNumber06 } from './number-06';
import { SvgNumber07 } from './number-07';
import { SvgNumber08 } from './number-08';
import { SvgNumber09 } from './number-09';
import { SvgNumber10 } from './number-10';
import styles from './learn-content-carousel-card-image.module.scss';
export type LearnContentCarouselCardImageProps = ImageWithFallbackProps & {
  callToActionText?: string;
  isAuthenticated: boolean;
  isLocked?: boolean;
  numberTranslation: string;
  svgNumber: number | undefined;
};
const numberSvgs: {
  [key: number]: ReactElement;
} = {
  1: <SvgNumber01 />,
  2: <SvgNumber02 />,
  3: <SvgNumber03 />,
  4: <SvgNumber04 />,
  5: <SvgNumber05 />,
  6: <SvgNumber06 />,
  7: <SvgNumber07 />,
  8: <SvgNumber08 />,
  9: <SvgNumber09 />,
  10: <SvgNumber10 />
};
export const LearnContentCarouselCardImage = t0 => {
  const $ = _c(23);
  const {
    alt,
    callToActionText,
    fallbackSrc,
    height,
    isAuthenticated,
    isLocked,
    numberTranslation,
    src,
    svgNumber,
    width
  } = t0;
  let t1;
  if ($[0] !== isAuthenticated || $[1] !== isLocked) {
    t1 = classnames(styles["image-container"], {
      [styles["image-container--is-locked"]]: isLocked,
      [styles["image-container--is-user-authenticated"]]: isAuthenticated
    });
    $[0] = isAuthenticated;
    $[1] = isLocked;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== numberTranslation || $[4] !== svgNumber) {
    t2 = svgNumber && <div aria-label={`${numberTranslation} ${svgNumber.toString()}`} className={styles.number} role="img">{numberSvgs[svgNumber]}</div>;
    $[3] = numberTranslation;
    $[4] = svgNumber;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== callToActionText || $[7] !== isLocked) {
    t3 = isLocked && <><LockIcon className={styles["image-container__icon"]} />{callToActionText && <span className={styles["image-container__call-to-action"]}>{callToActionText}</span>}</>;
    $[6] = callToActionText;
    $[7] = isLocked;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isLocked) {
    t4 = classnames(styles.image, {
      [styles["image--is-locked"]]: isLocked
    });
    $[9] = isLocked;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== alt || $[12] !== fallbackSrc || $[13] !== height || $[14] !== src || $[15] !== t4 || $[16] !== width) {
    t5 = <ImageWrapper alt={alt} className={t4} fallbackSrc={fallbackSrc} height={height} sizes="(min-width: 1920px) 15vw, (min-width: 1200px) 20vw, (min-width: 480px) 25vw, 50vw" src={src} width={width} />;
    $[11] = alt;
    $[12] = fallbackSrc;
    $[13] = height;
    $[14] = src;
    $[15] = t4;
    $[16] = width;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
    t6 = <div className={t1}>{t2}{t3}{t5}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};